<template>
  <div id="projList">
    <div v-bind:key="project_item.id" v-for="project_item in project_items">
      <!-- <Project v-bind:project_item="project_item" v-on:delete-project="deleteProject" :id="project_item.id" /> -->
      <Project v-bind:project_item="project_item" v-on:edit-project="editProject" v-on:delete-project="deleteProject" :id="project_item.id" />
    </div>
  </div>
</template>

<script>
import Project from '@/components/Project.vue'

export default {
  name: 'ProjectList',
  props: ["project_items"],
  components: {
    Project
  },
  methods: {
    editProject(uuid) {
      this.$emit('edit-project', uuid);
    },
    deleteProject(id) {
      this.$emit('delete-project', id);
    }
  }
}
</script>
